import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import NavigationBar from "../Components/NavigationBar";

const useStyles = makeStyles((theme) => ({
  app: {
    display: "flex",
    minHeight: "100vh",
    background: "#0A0A0A",
  },
  content: {
    width: "100%",
    padding: "80px 24px",
    [theme.breakpoints.down("xs")]: {
      padding: "56px 18px",
    },
  },
  eyebrow: {
    color: "#00FF41",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "0.8rem",
    fontWeight: 500,
    letterSpacing: "0.08em",
    marginBottom: "12px",
    textTransform: "uppercase",
  },
  title: {
    color: "#FFFFFF",
    fontSize: "clamp(2rem, 5vw, 3.5rem)",
    fontWeight: 700,
    lineHeight: 1.1,
    marginBottom: "24px",
  },
  section: {
    borderTop: "1px solid #1E1E1E",
    marginTop: "32px",
    paddingTop: "28px",
  },
  sectionTitle: {
    color: "#FFFFFF",
    fontSize: "1.2rem",
    fontWeight: 600,
    marginBottom: "12px",
  },
  text: {
    color: "#B0B0B0",
    fontSize: "1rem",
    lineHeight: 1.8,
    marginBottom: "14px",
  },
  list: {
    color: "#B0B0B0",
    lineHeight: 1.8,
    margin: "0 0 0 20px",
  },
  link: {
    color: "#00FF41",
    textDecoration: "none",
    "&:hover": {
      color: "#FFFFFF",
    },
  },
}));

export default function Privacy() {
  const classes = useStyles();

  return (
    <div className={classes.app}>
      <NavigationBar />
      <main className={classes.content}>
        <Container maxWidth="md">
          <Typography className={classes.eyebrow}>Privacy</Typography>
          <Typography component="h1" className={classes.title}>
            Site Analytics
          </Typography>
          <Typography className={classes.text}>
            This portfolio uses first-party visitor analytics to understand page
            traffic, troubleshoot issues, and protect the site.
          </Typography>

          <section className={classes.section}>
            <Typography component="h2" className={classes.sectionTitle}>
              Information collected automatically
            </Typography>
            <Typography className={classes.text}>
              When a page loads, the site may record basic request and browser
              metadata:
            </Typography>
            <ul className={classes.list}>
              <li>IP address</li>
              <li>User agent, browser language, platform, and client hints</li>
              <li>Referrer, page path, route name, and timestamp</li>
              <li>Viewport size, screen size, timezone, and device pixel ratio</li>
              <li>Anonymous visitor, session, and visit IDs</li>
            </ul>
          </section>

          <section className={classes.section}>
            <Typography component="h2" className={classes.sectionTitle}>
              Chat messages
            </Typography>
            <Typography className={classes.text}>
              If you use the recruiter chat, your messages may be processed and
              logged with request metadata, including IP address, so the feature
              can work and improve.
            </Typography>
          </section>

          <section className={classes.section}>
            <Typography component="h2" className={classes.sectionTitle}>
              Choices
            </Typography>
            <Typography className={classes.text}>
              The visitor tracker respects browser-level Global Privacy Control
              and Do Not Track signals. You can also contact me at{" "}
              <a className={classes.link} href="mailto:olms2074@gmail.com">
                olms2074@gmail.com
              </a>{" "}
              with privacy questions.
            </Typography>
          </section>
        </Container>
      </main>
    </div>
  );
}
